import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            实时更新的热门剧集排行榜，看看大家都在追什么
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
            {rankingData.map((item, index) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  index < rankingData.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-50/50 transition-colors`}
              >
                <div className="w-8 md:w-9 flex-shrink-0 text-center">
                  {item.rank <= 3 ? (
                    <span
                      className={`inline-flex items-center justify-center w-7 h-7 md:w-8 md:h-8 rounded-lg text-sm font-bold text-background-50 ${
                        item.rank === 1
                          ? 'bg-accent-500'
                          : item.rank === 2
                          ? 'bg-secondary-400'
                          : 'bg-secondary-500'
                      }`}
                    >
                      {item.rank}
                    </span>
                  ) : (
                    <span className="text-sm font-bold text-foreground-500">
                      {item.rank}
                    </span>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 truncate">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.category}</span>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className="text-sm font-medium text-primary-400 whitespace-nowrap">
                    {item.hot} 热度
                  </span>
                  <span className="text-xs">
                    {item.trend === 'up' && (
                      <i className="ri-arrow-up-line text-accent-500"></i>
                    )}
                    {item.trend === 'down' && (
                      <i className="ri-arrow-down-line text-foreground-500"></i>
                    )}
                    {item.trend === 'stable' && (
                      <i className="ri-subtract-line text-foreground-500"></i>
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}